export default __webpack_public_path__ + "static/media/img.c655c7a0.jpeg";